import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getKey, getTab, hasTabPermission } from '../../../shared/utils/tabsUtils';
import { usePermission } from '../../../shared/hooks/usePermission';
import pathRouts from '../../../shared/enums/pathRoute';
import Page from '../../../shared/components/ui/page/Page';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import Scroll from '../../../shared/components/ui/scroll/Scroll';
import FocusCarousel from '../../../shared/components/ui/focusCarousel/FocusCarousel';
import DomainCard from '../../../shared/components/pages/myLearningPage/domainCard/DomainCard';
import useMyLearningDomains from '../../../shared/components/pages/myLearningPage/useMyLearningDomains';
import MatriculationTimeLine from '../../../shared/components/pages/myLearningPage/matriculationTimeLine/MatriculationTimeLine';
import MyAssessmentsWidget from '../../../shared/components/pages/myLearningPage/myAssessmentsWidget/MyAssessmentsWidget';
import FinalProjectsWidget from '../finalProjects/finalProjectWidget/FinalProjectsWidget';
import PlusLearningWidget from '../plusLearningPage/plusLearningWidget/PlusLearningWidget';
import FinalProjectCarouselWidget from '../../../shared/components/widgetCarousel/finalProjectCarouselWidget/FinalProjectCarouselWidget';
import PlusLearningCarouselWidget from '../../../shared/components/widgetCarousel/plusLearningCarouselWidget/PlusLearningCarouselWidget';
import BgtWidget from '../bgtPage/bgtWidget/BgtWidget';
import BgtCarouselWidget from '../../../shared/components/widgetCarousel/bgtCarouselWidget/BgtCarouselWidget';
import classes from './MyLearningPage.module.css';

const MyLearningPage = () => {

    const navigate = useNavigate();
    const { texts } = useSelector(state => state.translate);
    const { isAuth, user, isStudent, userDetails } = useSelector(state => state.auth);
    const { lang } = useSelector(state => state.uiData) || {};
    const permissionLlist = useSelector((state) => state.uiData.permissionLlist);
    const permissionFilters = useSelector((state) => state.uiData.permissionFilters);
    const entities = useSelector(state => state.entities?.list);
    const myDomains = useMyLearningDomains();
    const archiveDomain = useSelector(state => state.uiData?.general?.archiveDomain)
    const hasPermission = usePermission();
    const canSeeBgt = hasPermission(getKey("bgt"));

    return (
        <Page title={texts.myLearning} icon={iconsList.myLearning} onBack={() => navigate(`/${pathRouts.HOME}`)}>
            <div className={classes.MyLearningPage}>
                <MatriculationTimeLine />
                <div className={classes.MyLearningContent}>
                    {(myDomains.length > 0 || archiveDomain) &&
                        <div className={classes.CoursesList}>
                            <div className={`${classes.ClassesScrollWrap} ${myDomains.length <= 1 ? classes.ClassesScrollWrapCompact : ''}`}>
                                <Scroll showDots={myDomains.length > 0}>
                                    <div className={classes.DomainsList}>
                                        {myDomains.map(domain =>
                                            <DomainCard key={domain.name} domain={domain} />
                                        )}
                                        <DomainCard domain={archiveDomain} link={`/${pathRouts.MYLEARNING}/${pathRouts.DOMAIN}/${pathRouts.ARCHIVE}`} />
                                    </div>
                                </Scroll>
                            </div>
                        </div>
                    }
                    <div className={classes.LeftSide}>
                        <div className={classes.DesktopWidgets}>
                            <MyAssessmentsWidget />
                            {canSeeBgt && <BgtWidget />}
                            {hasTabPermission(user, userDetails, isStudent, lang, getTab("finalProjects")?.visibleTo, permissionLlist, null, entities, permissionFilters)
                                && <FinalProjectsWidget />}
                            <PlusLearningWidget />
                        </div>
                        <FocusCarousel itemSize={100} activeScale={1.6} showDots={false} className={classes.WidgetsCarousel}>
                            {hasPermission(getTab("bgt")?.visibleTo) && <BgtCarouselWidget />}
                            {hasTabPermission(user, userDetails, isStudent, lang, getTab("finalProjects")?.visibleTo, permissionLlist, null, entities, permissionFilters) && <FinalProjectCarouselWidget />}
                            <PlusLearningCarouselWidget />
                        </FocusCarousel>
                    </div>
                </div>
            </div>
        </Page>
    );
};

export default MyLearningPage;